// extracted by mini-css-extract-plugin
module.exports = {"wrapCard":"styles_wrapCard__1H7fa","description":"styles_description__3w7Zu","rowActions":"styles_rowActions__8WJ5A"};